//messages.js
export default {
  general: 'General',
  overview: 'Visión de conjunto',
  customizer: 'Personalizador',
  applications: 'Aplicaciones',
  features: 'Caracteristicas',
  components: 'Componentes',
  salesAndVisitStats: 'Estadísticas de ventas y visitas',
  orderAndProjectStats: 'Estadísticas de pedidos y proyectos',
  fitnessStats: 'Estadísticas de estado físico',
  supportAndUsefulWidgets: 'Soporte y widgets útiles',
  dashboard: 'Tablero',
  dashboardOverview: 'Vista general del tablero',
  dashboardv1: 'Tablero V1',
  dashboardv2: 'Tablero V2',
  widgets: 'Widgets',
  horizontalMenu: 'Menú horizontal',
  pages: 'Páginas',
  gallery: 'Galería',
  pricing1: 'Precios 1',
  pricing2: 'Precios 2',
  blank: 'Blanco',
  session: 'Sesión',
  signUp1: 'Regístrese 1',
  signUp2: 'Registrarse 2',
  login1: 'Login 1',
  login2: 'Login 2',
  lockScreen: 'Bloquear pantalla',
  uiElements: 'Elementos de UI',
  buttons: 'Botones',
  cards: 'Tarjetas',
  checkbox: 'Caja',
  carousel: 'Carrusel',
  chips: 'Papas fritas',
  datepicker: 'Selector de fechas',
  dialog: 'Diálogo',
  grid: 'Cuadrícula',
  input: 'Entrada',
  list: 'Lista',
  menu: 'Menú',
  progress: 'Progreso',
  radio: 'Radio',
  select: 'Seleccionar',
  slider: 'Control deslizante',
  snackbar: 'Snackbar',
  tabs: 'Pestañas',
  toolbar: 'Barra de herramientas',
  tooltip: 'Información sobre herramientas',
  timepicker: 'Timepicker',
  forms: 'Formularios',
  formValidation: 'Validación de formulario',
  stepper: 'Paso a paso',
  charts: 'Gráficos',
  vueChartjs: 'Vista de Chartjs',
  vueEcharts: 'Vue Echarts',
  icons: 'Iconos',
  themify: 'Themify',
  material: 'Material',
  tables: 'Mesas',
  standard: 'Estándar',
  slots: 'Slots',
  selectable: 'Seleccionable',
  searchRow: 'Fila de búsqueda',
  maps: 'Mapas',
  googleMaps: 'mapas de Google',
  leafletMaps: 'Mapas de folletos',
  jvectorMap: 'Mapa Jvector',
  inbox: 'Bandeja de entrada',
  users: 'Usuarios',
  userProfile: 'Perfil del usuario',
  usersList: 'Lista de usuarios',
  calendar: 'Calendario',
  editor: 'Editor',
  quillEditor: 'Quill Editor',
  wYSIWYG: 'WYSIWYG',
  vue2Dragula: 'Vue2 Dragula',
  dragAndDrop: 'Arrastrar y soltar',
  vueDraggable: 'Vue Draggable',
  draggableResizeable: 'Dragizable Resizeable',
  chat: 'Charla',
  todo: 'Todo',
  modules: 'Módulos',
  user: 'Usuario',
  miscellaneous: 'Diverso',
  promo: 'Promoción',
  connections: 'Conexiones',
  follow: 'Seguir',
  unfollow: 'Dejar de seguir',
  basicValidation: 'Validación Básica',
  validationWithSubmitAndclear: 'Validación con submit & clear',
  submit: 'Enviar',
  clear: 'Claro',
  step1: 'Paso 1',
  step2: 'Paso 2',
  step3: 'Paso 3',
  continue: 'Continuar',
  cancel: 'Cancelar',
  totalEarnings: 'Ganancias Totales',
  onlineRevenue: 'Ingresos en línea',
  offlineRevenue: 'Ingresos sin conexión',
  marketingExpenses: 'Gastos de mercadotecnia',
  newCustomers: 'nuevos clientes',
  visitAndSalesStatistics: 'Estadísticas de visita y ventas',
  collapse: 'Colapso',
  reload: 'Recargar',
  close: 'Cerca',
  bandwidthUsage: 'Uso de Ancho de Banda',
  shoppingCart: 'Carrito de compras',
  totalDownloads: 'Descargas totales',
  productSales: 'Venta de productos',
  projectStatus: 'Estado del proyecto',
  averageSteps: 'Pasos promedio',
  todaysDistance: "Distancia de hoy",
  todaysStep: "El paso de hoy",
  todaysGoal: "Meta de hoy",
  calories: 'Calorías',
  weeklySummary: 'Resumen semanal',
  supportTickets: 'Boletos de soporte',
  todoList: 'Lista de quehaceres',
  newsletterCampaign: 'Campaña del boletín',
  currentVisitors: 'Visitantes actuales',
  newMembers: 'Nuevos miembros',
  addNewBlog: 'Agregar nuevo blog',
  add: 'Añadir',
  logOut: 'Añadir',
  totalAppMemory: 'Total de memoria de la aplicación',
  totalMemoryUsed: 'Memoria total utilizada',
  unreadMail: '12 correo no leído',
  feedback: 'Realimentación',
  flatButton: 'Botón plano',
  raisedButton: 'Botón elevado',
  gradientButton: 'Botón de degradado',
  buttonDropdownVariants: 'Variantes desplegables de botones',
  buttonToggle: 'Botón Alternar',
  icon: 'Icono',
  normal: 'Normal',
  disabled: 'Discapacitado',
  floating: 'Flotante',
  loaders: 'Cargadores',
  sizing: 'Dimensionamiento',
  outline: 'contorno',
  round: 'Redondo',
  block: 'Bloquear',
  search: 'Buscar',
  checkboxesBoolean: 'Casillas de verificación Booleanas',
  checkboxesArray: 'Casillas de verificación Matriz',
  checkboxesStates: 'Casillas de verificación: estados',
  checkboxesColors: 'Casillas de verificación - Colores',
  switches: 'Interruptores',
  default: 'Defecto',
  customTransition: 'Transición personalizada',
  customDelimiter: 'Delimitador personalizado',
  hideControls: 'Ocultar controles',
  hideDelimiters: 'Ocultar delimitadores',
  colored: 'De colores',
  label: 'Etiqueta',
  closeable: 'Cerrable',
  datePickerHorizontal: 'Selector de fecha horizontal',
  datePickerVertical: 'Selector de fecha vertical',
  datePickersInDialogAndMenu: 'Selector de Fecha- En Diálogo y Menú',
  datePickersWithModal: 'Selector de fecha con modal',
  datePickersFormattingDate: 'Selector de fecha: fecha de formateo',
  simpleDialogs: 'Cuadros de diálogo simples',
  withoutActivator: 'Sin activador',
  scrollable: 'Desplazable',
  listOfAllMaterialIcons: 'Lista de todos los iconos de material',
  arrowsAndDirectionsIcons: 'FLECHAS Y ICONOS DE DIRECCIÓN',
  webAppIcons: 'ICONOS DE APLICACIONES WEB',
  CONTROLICONS: 'ICONOS DE CONTROL',
  TEXTEDITOR: 'EDITOR DE TEXTO',
  LAYOUTICONS: 'ICONOS DE DISEÑO',
  BRANDICONS: 'ICONOS DE MARCA',
  newClients: 'Nuevos clientes',
  recurringClients: 'Clientes recurrentes',
  bounceRate: 'Porcentaje de rebote',
  pageViews: 'Vistas de página',
  usefulWidgets: 'Widgets útiles',
  sale: 'Venta',
  sales: 'Ventas',
  invoices: 'Facturas',
  referrals: 'Referencias',
  serverLoad: 'Carga del servidor',
  recentSale: 'Venta reciente',
  supportRequest: 'Solicitud de soporte',
  productSale: 'Venta de productos',
  viewAll: 'VER TODO',
  barChart: 'Gráfico de barras',
  polarAreaChart: 'Gráfico de área polar',
  lineChart: 'Gráfico de linea',
  radarChart: 'Gráfico de radar',
  doughnutChart: 'Carta de Donut',
  bubbleChart: 'Gráfico de burbujas',
  gradientLineChart: 'Gradient Line Chart',
  pieChart: 'Gráfico circular',
  funnelChart: 'Gráfico de embudo',
  loginNow: 'Inicia sesión ahora',
  createAccount: 'Crear una cuenta',
  termsOfService: 'Términos de servicio',
  bySigningUpYouAgreeTo: 'Al registrarte aceptas',
  loginToAdmin: 'Ingresar a la administración',
  enterUsernameAndPasswordToAccessControlPanelOf: 'Ingrese nombre de usuario y contraseña para acceder al panel de control de',
  havingAnAccount: 'Tener una cuenta?',
  quickLinks: 'enlaces rápidos',
  plans: 'Planes',
  chooseThePlanThatWorksForYou: 'Elija el plan que funcione para usted.',
  monthly: 'Mensual',
  yearlyGet2MonthExtra: 'Anualmente (obtenga 2 meses adicionales)',
  basic: 'BASIC',
  pro: 'Pro',
  advanced: 'Avanzado',
  basicFree: 'Básico (Gratis)',
  startToBasic: 'Comience a básico',
  upgradeToPro: 'Actualizar a Pro.',
  upgradeToAdvance: 'Actualizar a Advance',
  comparePlans: 'Comparar planes',
  frequentlyAskedQuestions: 'Preguntas frecuentes',
  defaultInput: 'Entrada predeterminada',
  activator: 'Activador',
  hover: 'Flotar',
  menus: 'Menús',
  indeterminate: 'Indeterminado',
  sizeAndWidth: 'Tamaño y ancho',
  rotate: 'Girar',
  determinate: 'Determinado',
  buffer: 'Buffer',
  radiosDefault: 'Radios predeterminados',
  radiosDirectionRow: 'Línea de dirección de radios',
  radiosDirectionColumn: 'Columna de dirección de radios',
  radiosColors: 'Radios - Colores',
  switchesColors: 'Interruptores - Colores',
  continuous: 'Continuo',
  discrete: 'Discreto',
  customColors: 'Colores personalizados',
  editableNumericValue: 'Valor numérico editable',
  contextualSnackbar: 'Barra de snack contextual',
  showSnackbar: 'Mostrar Snackbar',
  centeredTabs: 'Fichas centradas',
  toolbarTabs: 'Pestañas de la barra de herramientas',
  theDefaultColorToolbar: 'La barra de herramientas de color predeterminada',
  appBar: 'Barra de aplicaciones',
  appBarWithExtension: 'Barra de aplicaciones con extensión',
  visibility: 'Visibilidad',
  top: 'Parte superior',
  right: 'Derecha',
  bottom: 'Fondo',
  left: 'Izquierda',
  toggle: 'Palanca',
  timePicker: 'Selector de tiempo',
  timePickerInDialogAndMenu: 'Selector de tiempo: en el cuadro de diálogo y el menú',
  itemsAndHeaders: 'Artículos y encabezados',
  selectableRows: 'Filas seleccionables',
  headerCell: 'Header CellHeader Cell',
  expand: 'Expandir',
  recentChat: 'Chat reciente',
  previousChats: 'Chats anteriores',
  addNewItems: 'Agregar nuevos artículos',
  addToDo: 'Añadir para hacer',
  yes: 'Sí',
  ok: 'De acuerdo',
  activeUsers: 'Usuarios activos',
  addNew: 'Agregar nuevo',
  readMore: 'Lee mas',
  assignNow: 'Asignar ahora',
  totalRequest: 'Solicitud total',
  new: 'Nuevo',
  pending: 'Pendiente',
  update: 'Actualizar',
  updated10MinAgo: 'Actualizado hace 10 min',
  addNewCustomer: 'Añadir nuevo cliente',
  name: 'Nombre',
  email: 'Email',
  editMember: 'Editar miembro',
  scheduleDate: 'Fecha de programacion',
  title: 'Título',
  newEmails: 'Nuevos correos electrónicos',
  newEmail: 'Nuevo Email',
  employeePayroll: 'Nómina de empleados',
  forMostOfTheUsers: 'Para la mayoría de los usuarios',
  choosePlan: 'Elija Plan',
  mega: 'Mega',
  master: 'Dominar',
  forDeveloper: 'Para desarrollador',
  forLargeEnterprises: 'Para grandes empresas',
  composeEmail: 'Escribir correo',
  mailboxes: 'Buzones',
  folders: 'Carpetas',
  inbox5: 'Bandeja de entrada (5)',
  draft: 'Borrador',
  starred: 'Sembrado de estrellas',
  sentMessages: 'Mensajes enviados',
  spam: 'Correo no deseado',
  delete: 'Borrar',
  work: 'Trabajo',
  personal: 'Personal',
  manageFolders: 'Administrar carpetas',
  contacts: 'Contactos',
  settings: 'Configuraciones',
  themeOptions: 'Opciones de tema',
  darkMode: 'Modo oscuro',
  collapseSidebar: 'Contraer la barra lateral',
  boxLayout: 'Diseño de caja',
  rtlLayout: 'Diseño Rtl',
  backgroundImage: 'Imagen de fondo',
  sidebarFilters: 'Filtros de la barra lateral',
  danger: 'Peligro',
  primary: 'Primario',
  warning: 'Advertencia',
  success: 'Éxito',
  info: 'Información',
  dailySales: 'Ventas diarias',
  trafficChannel: 'Canal de tráfico',
  campaignPerformance: 'Rendimiento de la campaña',
  goToCampaign: 'Ir a Campaña',
  fullScreen: 'Pantalla completa',
  ecommerce: 'E-Commerce',
  shop: 'tienda',
  cart: 'Carro',
  total: 'Total',
  totalPrice: 'Precio total',
  viewCart: 'Ver carro',
  checkout: 'Revisa',
  apply: 'Aplicar',
  noItemsFound: 'No se encontraron artículos',
  billingDetails: 'Detalles de facturación',
  placeOrder: 'Realizar pedido',
  addNewCard: 'Agregar nueva tarjeta',
  devicesShare: 'Dispositivos compartidos',
  customerOverview: 'Descripción del cliente',
  reviews: 'Comentarios',
  weeklySales: 'Ventas semanales',
  recentOrders: 'órdenes recientes',
  categorySales: 'Categoría Ventas',
  webAnalytics: 'analista de la red',
  topSelling: 'Más vendidos',
  social: 'Social',
  newPost: 'Nueva publicación',
  publish: 'Publicar',
  magazine: 'Revista',
  editUser: 'editar usuario',
  addNewUser: 'Añadir nuevo usuario',
  dark: 'Oscuro',
  light: 'Ligero',
  recentUsers: 'Usuarios recientes',
  activityAroundWorld: 'Actividad alrededor del mundo',
  adsIncome: 'Ingresos de anuncios',
  recentComments: 'Comentarios Recientes',
  recentNotifications: 'Notificaciones recientes',
  messages: 'Mensajes',
  edit: 'Editar',
  topAuthors: 'Autores principales',
  marketingCampaign: 'CAMPAÑA de Marketing',
  articles: 'Artículos',
  websiteTraffic: 'Tráfico del sitio web',
  agency: 'Agencia',
  recent: 'Reciente',
  trending: 'Tendencias',
  totalPageViews: 'Páginas vistas en total',
  impressions: 'Impresiones',
  deviceSeparations: 'Separaciones de dispositivos',
  browserStatics: 'Estadísticas del navegador',
  totalDownloading: 'Descarga total',
  notifications: 'Notificaciones',
  totalBookmarked: 'Total marcado como favorito',
  itemsDownloads: 'Artículos Descargas',
  itemsUploaded: 'Artículos cargados',
  totalAnalytics: 'Total Analytics',
  hotKeywords: 'Palabras clave calientes',
  MaleUsers: 'Usuarios Masculinos',
  serverStatus: 'El estado del servidor',
  purchaseVuely: 'Compra Vuely',
  letsGetInTouch: 'Mantengámonos en contacto',
  maleUsers: 'Usuarios Masculinos',
  femaleUsers: 'Usuarios femeninos',
  androidUsers: 'Usuarios de Android',
  iOSUsers: 'Usuarios de iOS',
  advance: 'Avanzar',
  routerAnimation: 'Animación de enrutador',
  salesAndEarning: 'Ventas y Ganancias',
  netProfit: 'Beneficio neto',
  totalExpences: 'Gastos totales',
  photos: 'Fotos',
  adCampaignPerfomance: 'Campaña publicitaria Perfomance',
  profitShare: 'División de ganancias',
  topSellingTheme: 'Tema más vendido',
  newRequest: 'Nueva solicitud',
  followers: 'Seguidores',
  mailbox: 'Buzón',
  sent: 'Expedido',
  birthdays: 'Cumpleaños',
  events: 'Eventos',
  newsletter: 'Hoja informativa',
  lastMonth: 'El mes pasado',
  allTime: 'Todo el tiempo',
  composeNewEmail: 'Componer nuevo correo electrónico',
  activity: 'Actividad',
  message: 'Mensaje',
  selectTheme: 'Seleccione el tema',
  continueShopping: 'Seguir comprando',
  proceedToCheckout: 'Pasar por la caja',
  headerFilters: 'Filtros de encabezado',
  blog: "Blog",
  signUp: "BlogRegistrarse",
  login: "Iniciar sesión",
  news: "Noticias",
  topHeadlines: "Titulares principales",
  visitors: "Visitantes",
  subscribers: "Suscriptores",
  twitterFeeds: "Twitter Feeds",
  extensions: "Extensiones",
  imageCropper: "Imagen Cropper",
  videoPlayer: "Reproductor de video",
  dropzone: "Zona de descenso",
  baseConfig: "Configuración de base",
  audioTrackAndPlaysInline: "Pista de audio y reproducciones en línea",
  hlsLive: "HLS Live",
  forgotPassword: "Se te olvidó tu contraseña",
  resetPassword: "Restablecer la contraseña",
  backToSignIn: "Volver a iniciar sesión",
  enterYourEmailToSendYouAResetLink: "Ingrese su correo electrónico para enviarle un enlace de reinicio",
  pleaseEnterYourPasswordToReset: "Por favor ingrese su contraseña para restablecer",
  saas: "SAAS",
  overallTrafficStatus: "Estado general del tráfico",
  projectManagement: "Gestión de proyectos",
  projectTaskManagement: "Project Task Management",
  totalSales: "Ventas totales",
  simple: "Sencillo",
  transitions: "Transiciones",
  tax: "Impuesto",
  expenses: "Gastos",
  images: "Imágenes",
  ratings: "Calificaciones",
  containAndCover: 'Contener y cubrir',
  height: 'Altura',
  fixedRatio: 'Proporción fija',
  gradients: 'Gradientes',
  sizeVariants: 'Variantes de tamaño',
  newIcons: 'Nuevos iconos',
  webApplication: 'Aplicación web',
  person: 'Persona',
  file: 'Archivo',
  comment: 'Comentario',
  form: 'Formar',
  hardware: 'Hardware',
  directional: 'Direccional',
  mapAliases: 'Mapa (alias)',
  dateAndTime: 'Fecha y hora'
}
